import { render, staticRenderFns } from "./AIQuestion.vue?vue&type=template&id=bcb4a0d4&scoped=true&"
import script from "./AIQuestion.vue?vue&type=script&lang=js&"
export * from "./AIQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AIQuestion.vue?vue&type=style&index=0&id=bcb4a0d4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb4a0d4",
  null
  
)

export default component.exports